import { render, staticRenderFns } from "./DynamicSessionTags.vue?vue&type=template&id=3b6ab3ce&scoped=true&"
import script from "./DynamicSessionTags.vue?vue&type=script&lang=js&"
export * from "./DynamicSessionTags.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSessionTags.vue?vue&type=style&index=0&id=3b6ab3ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ab3ce",
  null
  
)

component.options.__file = "DynamicSessionTags.vue"
export default component.exports